import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'z-panel-spacer',
  templateUrl: './panel-spacer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelSpacerComponent {}
